import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ItemHdrQueryCriteriaClass, ItemHdrCriteriaModelQuery } from '../../../criteria/item-hdr-criteria.model';
import { BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { FinancialItemContainerModel, FinancialItemQueryCriteria } from '../../../../../../models/aggregates/erp/financial';
import { bl_fi_mst_item_ext_RowClass } from "../../../../../../models/dbschema";
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { Optional } from 'typescript-optional';
import { ItemCompanyBranchLinkContainerModel } from '../../../../../../models/aggregates/erp/item-company-branch/item-company-branch-container.model';

@Injectable({
  providedIn: 'root'
})
export class ItemCompanyBranchLinkService extends BaseApiTemplateService<ItemCompanyBranchLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-company-branch-link';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-company-branch-link';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-company-branch-link';
    this.httpClient = http;
  }

}
